/**
 * Moast Carousel Shadow DOM Style Injector
 * Injects custom CSS into moast-carousel shadow root once loaded
 */

(function() {
  'use strict';

  // CSS to inject into shadow root
  const customStyles = `
    /* MOAST CAROUSEL CUSTOM STYLES */
    moast-carousel {
      --moast-aspect-ratio: 1 !important;
      display: block !important;
      width: 100% !important;
      position: relative !important;
    }

    .carousel {
      --moast-aspect-ratio: 1/1 !important;
      --moast-slide-size: 600px !important;
      aspect-ratio: 1 !important;
    }


    /* No arrows: the videos are a swipe slider (track set up in setupSlider below) */
    .carousel__prev,
    .carousel__next {
      display: none !important;
    }

    .slides {
      transform: none !important;
      overflow-x: auto !important;
      scroll-snap-type: x mandatory;
      scrollbar-width: none;
      overscroll-behavior-x: contain;
      cursor: grab;
    }

    .slides::-webkit-scrollbar {
      display: none;
    }

    .slides.is-dragging {
      scroll-snap-type: none;
      cursor: grabbing;
    }

    .slides {
      width: 100% !important;
    }

    /* Exactly one video per view at any column width - never a sliver of the next one */
    .slide {
      transform: none !important;
      scroll-snap-align: start;
      margin: 0 !important;
      flex: 0 0 100% !important;
      width: 100% !important;
      max-width: none !important;
      min-width: 100% !important;
    }

    .card-container,
    .card-wrapper,
    .card {
      width: 100% !important;
      max-width: none !important;
    }

    .slide {
      max-width: unset;
    }

    .card-wrapper {
      aspect-ratio: 1 !important;
    }

    /* Individual slides */
    .slide {
      aspect-ratio: 1 !important;
    }

    /* Custom pagination */
    .carousel-wrapper {
      position: relative !important;
    }

    /* Figma 8675:75410 — one square video at a time, story-style progress lines on a dark top fade */
    .carousel {
      overflow: hidden !important;
      border-radius: 2px !important;
    }

    .card,
    .card__player {
      border-radius: 2px !important;
    }

    .card {
      position: relative !important;
    }

    /* 30% dark wash + centred Instagram mark over each video */
    .card::after {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 2;
      pointer-events: none;
      background:
        url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34' fill='none' stroke='white' stroke-width='2'%3E%3Crect x='2' y='2' width='30' height='30' rx='8'/%3E%3Ccircle cx='17' cy='17' r='6.5'/%3E%3Ccircle cx='25.5' cy='8.5' r='0.75' fill='white' stroke='none'/%3E%3C/svg%3E")
          center / 34px 34px no-repeat,
        rgba(0, 0, 0, 0.3);
    }

    moast-mute {
      display: none !important;
    }

    .carousel-wrapper::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 35px;
      z-index: 9;
      pointer-events: none;
      border-radius: 2px 2px 0 0;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.48), rgba(0, 0, 0, 0) 100%);
    }

    .pagination {
      position: absolute !important;
      top: 17px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      display: flex !important;
      gap: 20px !important;
      margin: 0 !important;
      padding: 0 !important;
      z-index: 10 !important;
      width: calc(100% - 55px) !important;
    }

    .pagination span {
      position: relative;
      cursor: pointer;
      height: 2px !important;
      background-color: #fff !important;
      opacity: 0.5 !important;
      border-radius: 0 !important;
      transition: opacity 0.3s ease !important;
      flex: 1 !important;
    }

    .pagination span.active {
      opacity: 1 !important;
    }

    /* Bigger click target than the 2px line */
    .pagination span::before {
      content: '';
      position: absolute;
      inset: -8px 0;
    }

    .controls__branding {
      display: none !important;
    }

  `;

  /**
   * Create pagination dots based on slide count
   */
  function createPagination(shadowRoot, slideCount) {
    // Check if pagination already exists
    let pagination = shadowRoot.querySelector('.pagination');
    if (pagination) {
      return pagination;
    }

    // Create pagination container
    pagination = document.createElement('div');
    pagination.className = 'pagination';
    
    // Create spans for each slide
    for (let i = 0; i < slideCount; i++) {
      const span = document.createElement('span');
      if (i === 0) {
        span.classList.add('active');
      }
      pagination.appendChild(span);
    }

    // Find carousel wrapper and inject pagination
    const carouselWrapper = shadowRoot.querySelector('.carousel-wrapper');
    if (carouselWrapper) {
      carouselWrapper.appendChild(pagination);
      console.log(`✅ Pagination created with ${slideCount} dots`);
    }

    return pagination;
  }

  /**
   * Update active pagination dot based on active slide
   */
  function updateActiveDot(shadowRoot) {
    const slides = shadowRoot.querySelectorAll('.slide');
    const paginationDots = shadowRoot.querySelectorAll('.pagination span');
    
    if (!slides.length || !paginationDots.length) return;

    // Find active slide index
    let activeIndex = 0;
    slides.forEach((slide, index) => {
      if (slide.classList.contains('is-active')) {
        activeIndex = index;
      }
    });

    // Update pagination dots
    paginationDots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  /**
   * Observe slide changes to update pagination
   */
  function observeSlideChanges(shadowRoot) {
    const slidesContainer = shadowRoot.querySelector('.slides');
    if (!slidesContainer) return;

    const observer = new MutationObserver(() => {
      updateActiveDot(shadowRoot);
    });

    observer.observe(slidesContainer, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }

  /**
   * Turn the slides into a swipe slider: native scroll-snap for touch/trackpad, mouse drag on desktop, and the
   * progress lines jump to a slide. Moast's own (hidden) arrows are clicked to keep its active slide - and so which
   * video plays - in step with what is on screen.
   */
  function setupSlider(shadowRoot) {
    const track = shadowRoot.querySelector('.slides');
    if (!track || track.dataset.sliderReady) return;
    track.dataset.sliderReady = 'true';

    const slides = () => [...shadowRoot.querySelectorAll('.slide')];
    const lines = () => [...shadowRoot.querySelectorAll('.pagination span')];
    const currentIndex = () => Math.round(track.scrollLeft / (track.clientWidth || 1));
    const moastIndex = () => Math.max(0, slides().findIndex((slide) => slide.classList.contains('is-active')));

    const setActiveLine = (index) => {
      lines().forEach((line, i) => line.classList.toggle('active', i === index));
    };

    // Moast updates its active slide asynchronously (and wraps around), so step one click at a time
    let syncTimer;
    const syncMoast = (index, attempts = slides().length) => {
      clearTimeout(syncTimer);
      const current = moastIndex();
      if (current === index || attempts <= 0) return;
      const button = shadowRoot.querySelector(current < index ? '.carousel__next' : '.carousel__prev');
      if (!button) return;
      button.click();
      syncTimer = setTimeout(() => syncMoast(index, attempts - 1), 250);
    };

    const goTo = (index) => {
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    };

    let settle;
    track.addEventListener(
      'scroll',
      () => {
        setActiveLine(currentIndex());
        clearTimeout(settle);
        settle = setTimeout(() => syncMoast(currentIndex()), 150);
      },
      { passive: true }
    );

    lines().forEach((line, i) => line.addEventListener('click', () => goTo(i)));

    // Mouse drag (touch and trackpads already scroll natively)
    let startX = 0;
    let startScroll = 0;
    let dragged = false;
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      dragged = false;
      const onMove = (moveEvent) => {
        const delta = moveEvent.clientX - startX;
        if (!dragged && Math.abs(delta) < 5) return;
        dragged = true;
        track.classList.add('is-dragging');
        track.scrollLeft = startScroll - delta;
      };
      const onUp = (upEvent) => {
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        track.classList.remove('is-dragging');
        if (!dragged) return;
        const delta = upEvent.clientX - startX;
        const from = Math.round(startScroll / track.clientWidth);
        const step = Math.abs(delta) > track.clientWidth * 0.15 ? (delta < 0 ? 1 : -1) : 0;
        goTo(Math.min(slides().length - 1, Math.max(0, from + step)));
      };
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
    });

    // A drag shouldn't also open the fullscreen player
    track.addEventListener(
      'click',
      (event) => {
        if (!dragged) return;
        event.stopPropagation();
        event.preventDefault();
        dragged = false;
      },
      true
    );
    track.addEventListener('dragstart', (event) => event.preventDefault());

    setActiveLine(0);
  }

  /**
   * Inject styles and pagination into a moast-carousel element's shadow root
   */
  function injectStyles(carousel) {
    // Check if already injected
    if (carousel.dataset.stylesInjected === 'true') {
      return;
    }

    // Wait for shadow root to be available
    const checkShadowRoot = setInterval(() => {
      if (carousel.shadowRoot) {
        clearInterval(checkShadowRoot);
        
        // Check if style tag already exists
        const existingStyle = carousel.shadowRoot.querySelector('style[data-custom-injected]');
        if (existingStyle) {
          carousel.dataset.stylesInjected = 'true';
          return;
        }

        // Create and inject style tag
        const styleTag = document.createElement('style');
        styleTag.setAttribute('data-custom-injected', 'true');
        styleTag.textContent = customStyles;
        
        // Insert at the beginning of shadow root for lower specificity
        carousel.shadowRoot.insertBefore(styleTag, carousel.shadowRoot.firstChild);
        
        // Mark as injected
        carousel.dataset.stylesInjected = 'true';
        
        console.log('✅ Custom styles injected into moast-carousel shadow root');

        // Moast only renders its slides once the carousel scrolls into view, so watch for them instead of polling
        const shadowRoot = carousel.shadowRoot;
        const setUpSlides = () => {
          const slides = shadowRoot.querySelectorAll('.slide');
          if (!slides.length || !shadowRoot.querySelector('.slides')) return false;
          createPagination(shadowRoot, slides.length);
          observeSlideChanges(shadowRoot);
          updateActiveDot(shadowRoot);
          setupSlider(shadowRoot);
          return true;
        };

        if (!setUpSlides()) {
          const slidesObserver = new MutationObserver(() => {
            if (setUpSlides()) slidesObserver.disconnect();
          });
          slidesObserver.observe(shadowRoot, { childList: true, subtree: true });
        }
      }
    }, 100);

    // Stop looking for the shadow root after 10 seconds
    setTimeout(() => {
      clearInterval(checkShadowRoot);
    }, 10000);
  }

  /**
   * Process all existing moast-carousel elements
   */
  function processExistingCarousels() {
    const carousels = document.querySelectorAll('moast-carousel');
    carousels.forEach(carousel => {
      injectStyles(carousel);
    });
  }

  /**
   * Observe DOM for new moast-carousel elements
   */
  function observeNewCarousels() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            if (node.tagName && node.tagName.toLowerCase() === 'moast-carousel') {
              injectStyles(node);
            }
            // Check children
            const carousels = node.querySelectorAll && node.querySelectorAll('moast-carousel');
            if (carousels) {
              carousels.forEach(carousel => {
                injectStyles(carousel);
              });
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Initialize the injector
   */
  function init() {
    // Process existing carousels
    processExistingCarousels();
    
    // Observe for new carousels
    observeNewCarousels();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
